<template>
  <v-combobox
    :value="value"
    :items="suggestions"
    :search-input.sync="search"
    :label="label"
    :disabled="disabled"
    :error-messages="errorMessages"
    item-text="value"
    item-value="value"
    return-object
    multiple
    chips
    small-chips
    deletable-chips
    hide-selected
    clearable
    @input="handleInput"
  />
</template>

<script>
import { GET_FIELD_TAG_OPTIONS } from "@/store/fieldTags.module";
import { SHOW_SNACK } from "@/store/snack.module";

export default {
  name: "FieldTagsInput",
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    fieldTagTypeSlug: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      default: "",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    errorMessages: {
      type: [Array, String],
      default: () => [],
    },
  },
  data() {
    return {
      search: "",
      suggestions: [],
    };
  },
  mounted() {
    this.loadSuggestions();
  },
  watch: {
    fieldTagTypeSlug() {
      this.loadSuggestions();
    },
  },
  methods: {
    loadSuggestions() {
      return this.$store
        .dispatch(GET_FIELD_TAG_OPTIONS, {
          field_tag_type_slug: this.fieldTagTypeSlug,
        })
        .then((tags) => {
          this.suggestions = (tags || []).map((tag) => ({
            id: tag.id,
            value: tag.value,
          }));
        })
        .catch(() => {
          this.suggestions = [];
          this.$store.dispatch(SHOW_SNACK, {
            message: this.$t("GENERAL.UNEXPECTED_ERROR"),
            type: "error",
          });
        });
    },
    normalizeTag(item) {
      if (typeof item === "string") {
        const trimmed = item.trim();

        if (!trimmed) {
          return null;
        }

        const existing = this.suggestions.find(
          (suggestion) => suggestion.value.toLowerCase() === trimmed.toLowerCase()
        );

        return existing || { id: null, value: trimmed };
      }

      const value = (item?.value || "").trim();

      if (!value) {
        return null;
      }

      return {
        id: item.id ?? null,
        value,
      };
    },
    handleInput(items) {
      const previous = Array.isArray(this.value) ? [...this.value] : [];
      const normalized = (items || [])
        .map((item) => this.normalizeTag(item))
        .filter(Boolean);

      const unique = [];
      normalized.forEach((tag) => {
        if (!unique.some((item) => item.value.toLowerCase() === tag.value.toLowerCase())) {
          unique.push(tag);
        }
      });

      unique
        .filter(
          (tag) =>
            !previous.some(
              (item) => item.value.toLowerCase() === tag.value.toLowerCase()
            )
        )
        .forEach((tag) => {
          this.$emit("tag-added", tag);
        });

      this.$emit("input", unique);
      this.search = "";
    },
  },
};
</script>
